class trailerButton {
  constructor(element) {
    if (!element) {
      return false
    }

    element.onclick = function () {
      window.dispatchEvent(
        new CustomEvent('trailer-clicked', {
          detail: { link: jQuery(element) },
        })
      )
    }
  }
}

export default trailerButton
